import { useEffect, useState } from 'react';
import {
    fetchDocumentMediaBlob,
    getDocumentMediaSpaHref,
    isDocumentMediaPath,
} from '../redux/downloadDocumentMedia';

export const useAuthenticatedDocumentMedia = (relativeUrl) => {
    const [blobUrl, setBlobUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const isMediaPath = isDocumentMediaPath(relativeUrl);
    const downloadHref = isMediaPath ? getDocumentMediaSpaHref(relativeUrl) : null;

    useEffect(() => {
        if (!relativeUrl || !isMediaPath) {
            setBlobUrl(null);
            setLoading(false);
            setError(null);
            return undefined;
        }

        let revoked = false;
        let objectUrl = null;

        setLoading(true);
        setError(null);
        setBlobUrl(null);

        fetchDocumentMediaBlob(relativeUrl)
            .then((blob) => {
                if (revoked) {
                    return;
                }
                objectUrl = URL.createObjectURL(blob);
                setBlobUrl(objectUrl);
            })
            .catch((err) => {
                if (!revoked) {
                    setError(err);
                }
            })
            .finally(() => {
                if (!revoked) {
                    setLoading(false);
                }
            });

        return () => {
            revoked = true;
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [relativeUrl, isMediaPath]);

    return {
        blobUrl,
        loading,
        error,
        isMediaPath,
        downloadHref,
    };
};
